import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function CtaBand() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg bg-secondary-950 px-6 py-10 md:px-12 md:py-14">
          <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-secondary-800/60" aria-hidden="true" />
          <div className="absolute -bottom-20 -left-10 h-48 w-48 rounded-full bg-primary-900/40" aria-hidden="true" />
          <div className="relative flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
            <div className="max-w-xl">
              <h2 className="font-heading text-2xl font-bold leading-tight text-background-50 md:text-3xl">
                有新料，也有后续
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-200">
                如果你掌握可核实的公开信息，欢迎把线索交给我们；如果你想追踪某个话题的进展，也可以直接来信告诉我们。
                编辑部每周整理一次读者反馈，把值得跟进的方向列入更新计划。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-send-plane-line" aria-hidden="true" />
                提供线索
              </Link>
              <Link
                to="/topics"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-compass-3-line" aria-hidden="true" />
                逛话题库
              </Link>
            </div>
          </div>
          <p className="relative mt-8 flex items-center gap-2 text-xs text-background-300">
            <i className="ri-time-line" aria-hidden="true" />
            {siteInfo.workingHours} · 所有内容仅作话题观察与讨论参考
          </p>
        </div>
      </div>
    </section>
  );
}